import AbstractRepository from '@services/repositories/AbstractRepository';
import Cache from '@services/Cache';

export default class NtapsSendersRepository extends AbstractRepository {
    constructor() {
        super();
        this.setApiUrl('/vue/shipping/ntaps/senders');
    }

    async getAll() {
        if (Cache.get('ntaps-senders')) {
            return Cache.get('ntaps-senders');
        }

        return this.run().then((res) => {
            Cache.set('ntaps-senders', res);
            return Cache.get('ntaps-senders');
        });
    }
}
